import {TrackableEntity} from './../../fms.core/data/ChangeTrackable';

export class AmsVoyage extends TrackableEntity {
    id: number = 0;
    amsUserID: number = 0;
    userName: string = '';
    vesselName: string = '';
    lloyds: string = '';
    voyage: string = '';
    loadPort: string = '';
    lastPort: string = '';
    firstPort: string = '';
    loadETD: string | null = null;
    lastETD: string | null = null;
    firstETA: string | null = null;
    vesselIndex: number|null = null;
    lPortName: string = '';
    fPortName: string = '';
    uPortName: string = '';

    constructor(init?:Partial<AmsVoyage>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();
    }
}
